import { getAll } from '../../../api/airtable.js'

const state = {
  ready: false,
  performances: [],
  member: {}
}

const getters = {}
const actions = {
  /**
   * Set up deep calls
   */
  setup({commit}, mem) {
    commit('SET_READY', false)
    commit('SET_MEMBER', mem)
   
    // load performances 
    getAll('Performances', mem['Performances']).then(perfs => {
      commit('SET_PERFORMANCES', { perfs, mem })
    }).then(() => {
      commit('SET_READY', true)
    })
  }
}

const mutations = {
  SET_READY(state, ready) {
    state.ready = ready
  },
  SET_MEMBER(state, mem) {
    state.member = mem
  },
  SET_PERFORMANCES(state, { perfs, mem }) {
    // check if we have mutated
    if (state.member === mem) {
      state.performances = perfs
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
